import { Component } from '@angular/core';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { RolesPermissionService } from '../../../services/roles-permission.service';
import { IAnyoUser } from 'projects/app-core/src/auth/models/IAnyoUser';
import { AddRolesAndPermissionRequest } from '../../../models/addRolesAndPermissionRequest';
import { Permissions, Roles } from 'projects/app-core/src/auth/models/roles';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { AnyoTableComponent } from 'projects/app-core/src/app/models/AnyoTableComponent';
import { RolesAndPermissionGridResponseData } from '../../../models/rolesAndPermissionGridResponse';
import { RolesAndPermissionGridRequest } from '../../../models/rolesAndPermissionGridRequest';

interface UserData extends IAnyoUser {
  firebaseDetails: {
    roles: { color: string; value: string }[];
    additionalPermissions: { color: string; value: string }[];
  };
}

interface selectOptions {
  label: string;
  value: string;
}

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrl: './manage.component.scss',
})
export class ManageComponent extends AnyoTableComponent<RolesAndPermissionGridResponseData,RolesAndPermissionGridRequest> {
  displayAddAdmin = false;
  selectedUser!: UserData;
  userSpinner = false;
  listOfSelectedRoles: Roles[] = [];
  listOfSelectedPermission: Permissions[] = [];
  listOfRoles: selectOptions[] = [];
  listOfPermission: selectOptions[] = [];
  listOfData: UserData[] = [];

  isOkLoading = false;
  commonFlag = false;
  globalSearchInput = "";

  constructor(
    protected override auth: AuthService,
    protected toast: ToastService,
    private rolesPermissionService: RolesPermissionService,
    private utils: UtilsService,
  ) {
    super(auth,toast)
  }

  override async resetFilter(): Promise<void> {
    this.gridRequest = {
      page: this.pageNo,
      pageSize: this.pageSize,
      export: false,
      globalSearch: []
    }
    this.globalSearchInput = ""
    this.fetchConsoleUserGrid();
  }

  searchGlobal() {
    if (this.globalSearchInput.length) {
      this.gridRequest = {
        page: this.pageNo,
        pageSize: this.pageSize,
        export: false,
        globalSearch: []
      }
      this.gridRequest?.globalSearch?.push(
        this.globalSearchInput.trim(),
      );
      this.fetchConsoleUserGrid();
    }
  }

  override async getData(): Promise<void> {
    this.fetchConsoleUserGrid()
  }

  override async ready(user?: IAnyoUser): Promise<void> {
      if(user){
        this.pageLoading = true;
        this.rolesPermissionService.rolesAndPermission().subscribe({
          next: (value) => {
            this.listOfPermission = value.permission.map((data) => {
              return {
                label: data.replace(/([A-Z])/g, ' $1').trim(),
                value: data,
              };
            });
            this.listOfRoles = value.roles.map((data) => {
              return {
                label: data.replace(/([A-Z])/g, ' $1').trim(),
                value: data,
              };
            });
            this.pageLoading = false;
          },
          error: (error) => {
            const errorBody = error.error as IAnyoError;
            this.toast.showAnyoErrorToast(errorBody.description);
            this.pageLoading = false;
          },
        });
        if (user?.customClaims?.roles.includes(Roles.SuperAdmin)) {
          this.displayAddAdmin = true;
        }
        this.getData();
      }
  }

  fetchConsoleUserGrid(){
    this.pageLoading = true;
    this.rolesPermissionService.fetchConsoleUserGrid(this.gridRequest).subscribe({
      next: (value) => {
        const data: UserData[] = value.data.map((userData) => {
          const additionalPermissions = userData.firebaseDetails
            ? userData.firebaseDetails.additionalPermissions.map(
                (permission) => ({
                  value: permission,
                  color: this.utils.getRandomColor(),
                }),
              )
            : [];
          const roles = userData.firebaseDetails
            ? userData.firebaseDetails.roles.map((role) => ({
                value: role,
                color: this.utils.getRandomColor(),
              }))
            : [];

          return {
            ...userData,
            firebaseDetails: {
              ...userData.firebaseDetails,
              additionalPermissions,
              roles,
            },
          };
        });
        this.listOfData = data;
        this.pageNo = value.pageNum;
        this.totalCount = value.totalRecords;
        this.pageLoading = false;
      }, error: (err) => {
        this.pageLoading = false;
        const errorBody = err.error as IAnyoError;
        this.toast.showAnyoErrorToast(errorBody.description);
      }
    })
  }

  listUser() {
    this.rolesPermissionService.listData().subscribe({
      next: (users) => {
        const data: UserData[] = users.map((userData) => {
          const additionalPermissions = userData.firebaseDetails
            ? userData.firebaseDetails.additionalPermissions.map(
                (permission) => ({
                  value: permission,
                  color: this.utils.getRandomColor(),
                }),
              )
            : [];
          const roles = userData.firebaseDetails
            ? userData.firebaseDetails.roles.map((role) => ({
                value: role,
                color: this.utils.getRandomColor(),
              }))
            : [];

          return {
            ...userData,
            firebaseDetails: {
              ...userData.firebaseDetails,
              additionalPermissions,
              roles,
            },
          };
        });
        this.listOfData = data;
        this.userSpinner = false;
      },
      error: (error) => {
        this.userSpinner = false;
        const errorBody = error.error as IAnyoError;
        this.toast.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  isVisible = false;

  showModal(data: UserData) {
    this.selectedUser = data;
    this.isVisible = true;
    this.listOfSelectedPermission =
      data.firebaseDetails.additionalPermissions.map(
        (data) => data.value,
      ) as Permissions[];
    this.listOfSelectedRoles = data.firebaseDetails.roles.map(
      (data) => data.value,
    ) as Roles[];
  }

  handleOk(): void {
    this.isOkLoading = true;
    const request: AddRolesAndPermissionRequest = {
      email: this.selectedUser.email!,
      roles:
        this.listOfSelectedRoles.length > 0 ? this.listOfSelectedRoles : [],
      permissions:
        this.listOfSelectedPermission.length > 0
          ? this.listOfSelectedPermission
          : [],
    };
    this.rolesPermissionService.addRolesAndPermission(request).subscribe({
      next: (value) => {
        this.isVisible = false;
        this.isOkLoading = false;
        this.toast.showSuccess('Successfully Roles Updated');
        this.listUser();
      },
      error: (value) => {
        this.isVisible = false;
        this.isOkLoading = false;
        const errorBody = value.error as IAnyoError;
        this.toast.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  enableDisableForUserInAllColl(data: UserData) {
    this.userSpinner = true;
    const request = {
      consoleUserEnableDisableFlag: !data.active,
    };
    this.rolesPermissionService
      .enableDisableCommonFlagForUser(request, data.userId!)
      .subscribe({
        next: (value) => {
          this.userSpinner = false;
          this.toast.showSuccess('Update Successfully');
        },
        error: (error) => {
          const errorBody = error.error as IAnyoError;
          this.toast.showAnyoErrorToast(errorBody.description);
          this.userSpinner = false;
        },
      });
  }
}
